import React from 'react';
import PropTypes from 'prop-types';
import Currency from 'react-currency-formatter';

const ColorsListItem = props => {
  const { colorName, colorsList, changeMaterial } = props;

  const handleClick = item => {
    changeMaterial(item);
  };

  return (
    <div className="color-list__box">
      {colorsList.map((item, key) => (
        <div className="color-list__item" key={'color-list-item_' + key}>
          <button
            className={`color-list__button ${item.safo === colorName ? 'active' : ''}`}
            onClick={() => handleClick(item)}
            title={item.name}>
            <span
              className="color-list__img"
              style={{ backgroundImage: `url("${item.icon ?? item.img}")` }}
            />
            <span className="color-list__price">
              <Currency quantity={item.price.actual} currency="PLN" />
            </span>
          </button>
        </div>
      ))}
    </div>
  );
};

ColorsListItem.propTypes = {
  colorName: PropTypes.string,
  colorsList: PropTypes.array,
};

export default ColorsListItem;
